module.exports = __webpack_public_path__ + "static/media/search.58ee7c71.svg";